import { render, staticRenderFns } from "./static copy.vue?vue&type=template&id=1dc8481d&scoped=true"
import script from "./static copy.vue?vue&type=script&lang=js"
export * from "./static copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8481d",
  null
  
)

export default component.exports